/**
 * 方案 C 写 DPI 时会短暂切邻档再切回；期间固件 `statu` 会上报中间档。
 * 用时间窗抑制把中间档写进 UI store，避免选中态闪到 DPI2 等。
 */
let suppressStatuUntil = 0;

export function beginFreqDpiStatuSuppress(ms: number): void {
  const hold = Math.max(0, Math.floor(ms));
  if (hold <= 0) return;
  suppressStatuUntil = Math.max(suppressStatuUntil, Date.now() + hold);
}

export function isFreqDpiStatuSuppressed(): boolean {
  return Date.now() < suppressStatuUntil;
}
